// Keeping as separate action as this was causing circular dependencies
import { Intents } from "@certa/studio-core/src/constants/activityLogs.constants";
import { importRawSwimlanes } from "./swimlane.actions";
import { importJSONChanges as importJSONChangesUtil } from "./utils/importDesignAIJSONChange";
import { importJSONChangesV3 as importJSONChangesV2Util } from "./utils/importDesignAIJSONChangeV3";
import type { StepGroup as RawSwimlane } from "../../../types/rawProcess.types";

export const importJSONChanges = importJSONChangesUtil;
export const importJSONChangesV3 = importJSONChangesV2Util;

export const importBRDSwimlanes = ({
  processId,
  rawSwimlanes
}: {
  processId: string;
  rawSwimlanes: RawSwimlane[];
}) =>
  importRawSwimlanes({
    rawSwimlanes,
    processId,
    intent: Intents.IMPORT_BRD_SWIMLANE
  });
